import React, { ReactElement } from 'react';
import { Answer, QuestionSpec, Nullable, QuestionDocument, ButtonsSettings } from '../../../types/types';
import QuestionBox from "../box";
import QuestionValue from "../value";
import QuestionLabel from '../label';
import FileFieldViewer from '../../field/viewers/filefieldviewer';
import QuestionEditorButton from '../questioneditorbutton';

function FileQuestionViewer(props: {spec: QuestionSpec, answer: Nullable<Answer>, id: string, setAnswer?: (answer: Nullable<Answer>) => void, buttonsSettings?: ButtonsSettings, disableInput?: string}): ReactElement {
  const setValue = (value: Nullable<Answer['value']>) => {
    if (props.answer && props.setAnswer) {
      props.setAnswer({
        ...props.answer,
        value
      });
    }
  };
  
  return (
    <QuestionBox>
      <QuestionLabel spec={props.spec} />
      <QuestionValue>
        <FileFieldViewer id={props.id} value={props.answer?.value as QuestionDocument} />
      </QuestionValue>
      {props.setAnswer && props.buttonsSettings &&
        <QuestionEditorButton response={props.answer?.value} setResponse={setValue} defaultValue={props.answer?.value} buttonsSettings={props.buttonsSettings} previousAnswer />
      }
    </QuestionBox>
  );
}

export default FileQuestionViewer;
